export const Routes = {
  ROOT: '/',
  HOME: '/home',
  SUPER_ADMIN: '/superAdmin',
  GRUPOS: '/grupos',
  GRUPO_NOVO: '/grupos/novo',
  GRUPO: '/grupos/:id',
  DEALER_NOVO: '/dealers/novo',
  DEALER: '/dealers/:id',
  DEALERS: '/dealers',
  USUARIOS: '/usuarios',
  USUARIO_NOVO: '/usuarios/novo',
  USUARIO: '/usuarios/:id',
  AUSENCIA_TEMPORARIA: '/usuarios/:id/ausencia-temporaria',
  GRUPOS_USUARIOS: '/gruposUsuarios',
  GRUPO_USUARIOS_NOVO: '/gruposUsuarios/novo',
  GRUPO_USUARIOS: '/gruposUsuarios/:id',
  AUDITORIA: '/auditoria/:id/:tipo',
  BIBLIOTECA_VIRTUAL_PASTA: '/biblioteca/:idPasta',
  BIBLIOTECA_VIRTUAL: '/biblioteca',
  COMUNICADOS_NOVO: '/comunicados/novo',
  COMUNICADO_EDICAO: '/comunicados/editar/:id',
  COMUNICADO_ERRATA: '/comunicados/errata/:id',
  COMUNICADO_ENVIO_VISUALIZACAO: '/comunicados/visualizarEnvio/:id',
  COMUNICADO_VISUALIZACAO: '/comunicados/visualizar/:id',
  COMUNICADO_DASHBOARD: '/comunicados/dashboard/:id',
  COMUNICADOS: '/comunicados',
  MINHA_CONTA: '/minha-conta',
  SLIDES: '/slides',
  SLIDE_NOVO: '/slides/novo',
  SLIDE_EDICAO: '/slides/editar/:id',
  ANUNCIO_NOVO: '/anuncios/novo',
  ANUNCIO_EDICAO: '/anuncios/editar/:id',
  ANUNCIOS: '/anuncios',
  NOTIFICACOES: '/notificacoes',
  NOTIFICACOES_GENERICAS: '/notificacoesGenericas',
  NOTIFICACAO_NOVA: '/notificacoesGenericas/nova/:tipo',
  NOTIFICACAO_EDICAO: '/notificacoesGenericas/editar/:tipo/:id',
  IMPORTAR_USUARIOS: '/importarUsuarios',
  RELATORIO_PAGE: '/relatorio/:slug'
}
